import styled from '@emotion/styled';

const StyledFormWrapper = styled.div`
  margin-bottom: 20px;
  margin-top: 8px;
`;

export { StyledFormWrapper };
